import { useEffect, useState } from "react";
import Styles from "./index.module.scss";
import { emailOTPFormLogic } from "./formLogin";
import { ReactComponent as Arrow } from "../../../assets/icons/Arrow.svg";
import SendOTPForm from "./sendOTPForm";
import VerifyOTPForm from "./verifyOTPForm";
import { useAuthFrontLock } from '../../../context/useAuthFrontContext';
import { useScreen } from '../../../context/useScreen';
import i18n from "../../../utils/translations/i18n";
import { COOKIE_CONSTANT, ERROR_CODE, PAGE_NAME } from "../../../utils/constant/constant";
import { deleteCookie,  redirectToAuthcallback,  setCurrentPageCookie } from "../../../utils/utils/utils";

const EmailOTP = ({ isSignupForm }) => {
    const authFrontLock = useAuthFrontLock();
    const screenType = authFrontLock.getScreenType();
    const additionalParams = authFrontLock?.getAdditionalParams();
    const userEmail = (screenType === PAGE_NAME.EMAIL_OTP_VERIFY && additionalParams?.email) || '';
    const isBMLFlow = additionalParams?.isBMLFlow;
    
    // Initialize with the email if available
    const initialForm = JSON.parse(JSON.stringify(emailOTPFormLogic));
    if (userEmail) {
        initialForm.email.value = userEmail;
    }
    const [inputForm, setInputForm] = useState(initialForm);
    
    
    const [showVerifyPage, setShowVerifyPage] = useState(isBMLFlow || false);

    const screen = useScreen();
    const { t } = i18n;

    useEffect(() => {
        document.title = isSignupForm ?  t('sign_up.page_title') : t('sign_in.page_title');

        setCurrentPageCookie(isSignupForm ? PAGE_NAME.EMAIL_OTP_SIGN_UP : PAGE_NAME.EMAIL_OTP_SIGN_IN, additionalParams?.screenId);
      }, []);

    const sendOTPHandler = async () => {
        try {
            await authFrontLock.startPasswordlessAsync({ 
                username: inputForm.email.value, 
                channel: "EMAIL", 
                messageType: "CODE", 
                captcha: authFrontLock.getCaptchaToken() 
            });
        } catch (err : any) {
            if(err.errorCode === ERROR_CODE.REAUTHENTICATION_REQUIRED){
                deleteCookie(COOKIE_CONSTANT.CURRENT_PAGE_COOKIE_KEY);
                authFrontLock && redirectToAuthcallback(authFrontLock, ERROR_CODE.REAUTHENTICATION_REQUIRED, inputForm.email.value);
                return;
            }
            throw err;
        }
    }

    const handleBack = () => {
        if(isBMLFlow){
            const redirectUrl = `${process.env.REACT_APP_SITE_BASE_URL}/np-redirect?redirect_page=checkout-payment`;
            window.location.replace(redirectUrl);
            return;
        }
        if(showVerifyPage) {
            // Return Back to SendOTP Form
            setShowVerifyPage(false);
        } else {
            // Return back to Email-Password Form
            screen.setDisplayScreen(isSignupForm?PAGE_NAME.SIGN_UP:PAGE_NAME.SIGN_IN)
        }
    }

    return (
        <div className={Styles.container}>
            <div className={Styles.header}>
                <span id="handle-back-btn" className={Styles.backLink} onClick={handleBack} role="button" tabIndex={0}>
                    <Arrow/>
                    <span className={Styles.link}>{t('email_otp.back')}</span>
                </span>
                <h2 className={Styles.title}>{ isSignupForm ? t('sign_up.create_an_account') : t('sign_in.title') }</h2>
            </div>
            { showVerifyPage ? 
                <VerifyOTPForm email={inputForm.email.value} sendOTPHandler={sendOTPHandler} isSignupForm={isSignupForm} isBMLFlow={isBMLFlow}/>
                :
                <SendOTPForm form={inputForm} setFormState={setInputForm} setShowVerifyPage={setShowVerifyPage} sendOTPHandler={sendOTPHandler} isSignupForm={isSignupForm}/>
            }
        </div>
    );
};

export default EmailOTP;